import { html } from '@microsoft/fast-element';
import type { InfoIcon } from './info-icon';
import { infoIcon } from '../../../styles';

export const InfoIconTemplate = html<InfoIcon>`
    <div class="info-icon-tooltip">${infoIcon()}</div>
`;
